import { useEffect, useRef } from 'react';
import { useLocale } from 'next-intl';

//* Styles
import AboutUsSectionStyle from './style';

//* Components
import Text from '@/components/Text';
import Image from '@/components/Image';
import Container from '@/components/Container';
import useTrigger from '@/components/Animation/useTrigger';
import TextAnimation from '@/components/Animation/TextAnimation/TextAnimation';

//* Data
import { dataAboutUs } from '@/data';

const AboutUsSection = () => {
	const lang = useLocale();
	const titleRef = useRef();
	const descriptionRef = useRef();

	useEffect(() => {
		const trigger = useTrigger({
			ref: titleRef.current,
			documentPercent: 90,
			onEnter: () => {
				titleRef.current.children[0].classList.add('active');
				descriptionRef.current.classList.add('active');
			},
		});

		return () => {
			trigger();
		};
	}, []);

	return (
		<AboutUsSectionStyle>
			<Container isSection>
				<Text
					tag={'h2'}
					ref={titleRef}
					className={'h3 font-montserrat-arm-medium text-primary-color uppercase align-center'}>
					<TextAnimation text={dataAboutUs[lang].title} />
				</Text>

				<Container
					row
					full>
					<div className={'empty-col col-2 col-m-12'} />

					<Text
						ref={descriptionRef}
						className={'p2 col-8 col-m-12 about-description align-center'}>
						{dataAboutUs[lang].description}
					</Text>

					<div className={'empty-col col-2 col-m-12'} />
				</Container>

				<Image
					src={dataAboutUs[lang].image.src}
					alt={dataAboutUs[lang].image.alt}
				/>
			</Container>
		</AboutUsSectionStyle>
	);
};

export default AboutUsSection;
